import React from "react";

export default function GeneralStep({title, children}){
  return( 
  <div className="general-step">
  <h1 className="title">{title}</h1>
  {children}
  </div>)
}